export default {
	name: 'Name',
	nameError: 'Name darf nicht leer sein.',
	email: 'E-Mail-Adresse',
	emailRequiredError: 'E-Mail-Adresse darf nicht leer sein.',
	emailInvalidError: 'ungültige E-Mail-Adresse.',
	phone: 'Telefonnummer (optional)',
	phoneError: 'Ungültiges Telefonnummer.',
	title: 'Bitte benachrichtigen Sie mich, wenn die Boxgröße wieder verfügbar ist.',
	boxButton: 'Box anfragen',
	sendButton: 'Senden',
	privacyPolicy: 'Die Datenschutzerklärung habe ich gelesen und akzeptiert.',
	privacyPolicyError: 'Bitte akzeptieren Sie unsere Datenschutzerklärung.',
};